import { components } from "@certn/legacy-api/generated-schemas/people";

import { Section } from "../Application.context";

export function getCurrentAddressFromSections(
  sections: Section[]
): components["schemas"]["AddressesCheckFieldValue"] | undefined {
  let addressField: components["schemas"]["AddressesCheckField"] | undefined;

  sections.forEach(({ fields }) => {
    if (addressField) {
      return;
    }

    addressField = fields.find(({ type }) => type === "ADDRESSES") as
      | components["schemas"]["AddressesCheckField"]
      | undefined;
  });

  return addressField && addressField.value.find(({ end_date }) => !end_date);
}
